import type { FilterType, GlobalFilter } from '@hotjar/global-filters';

export function mergeGlobalFilters(
  defaultGlobalFilters: GlobalFilter,
  globalFilters: GlobalFilter,
): GlobalFilter {
  return {
    dateRange:
      globalFilters.dateRange === undefined
        ? defaultGlobalFilters.dateRange
        : globalFilters.dateRange,
    filterList: globalFilters.filterList
      .map((filter) =>
        filter.value === undefined
          ? defaultGlobalFilters.filterList.find((f) => f.kind === filter.kind)
          : filter,
      )
      .filter((f): f is FilterType => f !== undefined),
  };
}
